import { normalizeMentionLabel } from './mentionLabel.js'

export function buildMentionTargetLookup({ members = [], agents = [] } = {}) {
  /** @type {Map<string, ReturnType<typeof resolveMentionTarget>>} */
  const map = new Map()

  for (const agent of agents) {
    const key = normalizeMentionLabel(agent.name)
    if (key && !map.has(key)) {
      map.set(key, {
        kind: 'agent',
        id: agent.id,
        name: agent.name,
        role: agent.role,
        avatarSrc: agent.avatarSrc ?? null,
        avatarAlt: agent.avatarAlt ?? '',
      })
    }
  }

  for (const member of members) {
    const key = normalizeMentionLabel(member.name)
    if (key && !map.has(key)) {
      map.set(key, { kind: 'user', name: member.name, email: member.email })
    }
  }

  return map
}
